module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAYAAADam2dgAAAAVUlEQVR4AWPABv7//88KxPOAeD4Qs2FTwAfEO/8jwBZ0BdJAfAFJwUcgdkFWoAvEj2GyULYusgIXsC4ogJomjayAEWQvTBbqHj5sjmUD+QTqI1Z0eQBoiIRvvyvoTgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ideate/right-beam-2.png
// module id = 185
// module chunks = 35783957827783 112966903596346 114276838955818